import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import type { Unit } from '../types/api/generated';

export const globalApi = createApi({
    reducerPath: 'globalApi',
    baseQuery,
    endpoints: (builder) => ({
        submitChangeRequest: builder.mutation<Unit, unknown>({
            query: (body) => ({ url: 'api/v2/global/change-request', method: 'POST', body }),
        }),
        submitChangeRequestBatch: builder.mutation<Unit, unknown>({
            query: (body) => ({ url: 'api/v2/global/change-request-batch', method: 'POST', body }),
        }),
    }),
});

export const {
    useSubmitChangeRequestMutation,
    useSubmitChangeRequestBatchMutation,
} = globalApi;
